import { z } from '@repo/schema'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure.ts'

const TriggerSchema = z.object({
  label: z.string(),
  requires_days_and_period: z.boolean(),
  supports_dates: z.boolean(),
  value: z.string(),
})

const PeriodSchema = z.object({
  // Xero wording per party ("invoice" for the customer, "bill" for the carrier).
  carrier_label: z.string(),
  customer_label: z.string(),
  value: z.string(),
})

export const PaymentTermsOptionsSchema = z.object({
  periods: PeriodSchema.array(),
  preset_days: z.number().array(),
  triggers: TriggerSchema.array(),
})

export type PaymentTermsOptions = z.infer<typeof PaymentTermsOptionsSchema>

export const createPaymentTermsRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    options: p.path('payment-terms', 'options').query(({ path, upFetch }) =>
      upFetch(path, {
        schema: PaymentTermsOptionsSchema,
      }),
    ),
  }
}
